// src/utils/imageUrl.js
export function completeImageUrl(url) {
  if (!url) return null;
  
  // If already a full URL, return as is
  if (url.startsWith('http')) {
    return url;
  }
  
  // Get the API URL using the same logic as axiosConfig
  const getApiUrl = () => {
    const hostname = window.location.hostname;
    const port = '3001'; // Backend port
    
    // If running on a .life domain, prefer env host
    if (hostname.endsWith('.life')) {
      return process.env.REACT_APP_API_URL || `https://${hostname}`;
    }
    
    // If we're on a subdomain, use api.{subdomain}.lvh.me pattern
    if (hostname.includes('lvh.me')) {
      const parts = hostname.split('.');
      if (parts.length >= 2) {
        const subdomain = parts[0]; // tearoom, sexymood, etc.
        return `http://api.${subdomain}.lvh.me:${port}`;
      }
    }
    
    // Fallback to environment variable or localhost
    return process.env.REACT_APP_API_URL || `http://localhost:${port}`;
  };
  
  const backendUrl = getApiUrl();
  return `${backendUrl}${url}`;
}
